import React from 'react'

import formatter from '@/services/formatter'
import { colors } from '@/theme'

import Table, {
  TableCell as StyledTableCell,
  TableRow as StyledTableRow,
} from '@/components/Table'
import RenderTableRow from '@/components/Table/TableRow'

import {
  alpha,
  Box,
  TableContainer,
  Typography,
  useTheme,
} from '@material-ui/core'

// ----------------------------------------------------

export function CollectPrintTable(props) {
  const { data } = props

  const theme = useTheme()

  const TABLE_HEAD = [
    { title: 'PEDIDO', field: 'cod_pedido' },
    { title: 'ID', field: 'id_itens' },
    { title: 'PRODUTO', field: 'dsc_produto' },
    { title: 'LOTE', field: 'itped_lote' },
    {
      title: 'QUANTIDADE',
      field: 'vpt_qtd',
      cellFormat: 'decimal',
      align: 'right',
    },
    {
      title: 'PESO',
      field: 'vpt_peso_bruto',
      cellFormat: 'decimal',
      align: 'right',
    },
    {
      title: 'PAL',
      field: 'vpt_pallet',
      align: 'right',
    },
    {
      title: 'CXS',
      field: 'vpt_qtd_caixas',
      align: 'right',
    },
    {
      title: 'UN',
      field: 'id_un_medidas',
      align: 'right',
    },
    // {
    //   title: 'ENTREGA',
    //   field: 'vpt_data_prev_entrega',
    //   cellFormat: 'date',
    // },
    // { title: 'FRETE', field: 'ped_tipo_frete' },
    { title: 'REPRESENTANTE', field: 'ped_representante' },
  ]

  const summary = React.useMemo(() => {
    return data.reduce(
      (acc, item) => {
        if (item.id_un_medidas === 'M2') {
          acc.amount += Number(item.vpt_qtd)
          acc.amountPallets += Number(item.vpt_pallet)
          acc.amountBoxes += Number(item.vpt_qtd_caixas)
        }
        acc.weight += Number(item.vpt_peso_bruto)
        return acc
      },
      {
        weight: 0,
        amount: 0,
        amountPallets: 0,
        amountBoxes: 0,
      }
    )
  }, [data])

  const getCellStyle = () => {
    return {
      padding: theme.spacing(1),
    }
  }

  return (
    <Box
      component={TableContainer}
      sx={{ border: '1px solid', borderColor: alpha(colors.color100, 0.33) }}
      borderRadius={2}
    >
      <Table
        groupBy="cod_cliente"
        size="medium"
        data={data}
        columns={TABLE_HEAD}
        stripped={false}
        cellStyle={getCellStyle}
        components={{
          Group: ({ rowData: row }) => {
            const customer = row.customer

            const description = customer.emp_razao_social?.concat(
              formatter(row.cod_cliente).toCNPJorCPF()
            )

            return (
              <StyledTableRow>
                <StyledTableCell
                  colSpan={TABLE_HEAD.length}
                  style={{
                    borderBottom: `1px solid ${colors.color300}`,
                  }}
                >
                  <Box mt={1}>
                    <Typography
                      component="span"
                      variant="body2"
                      style={{ fontWeight: 'bold' }}
                    >
                      {description}
                    </Typography>

                    <Typography component="span" variant="body2">
                      {customer.emp_endereco}
                    </Typography>
                  </Box>
                </StyledTableCell>
              </StyledTableRow>
            )
          },
          Footer: (props) => {
            return (
              <RenderTableRow
                {...props}
                rowData={{
                  cod_pedido: 'TOTAL',
                  vpt_qtd: summary.amount,
                  vpt_peso_bruto: summary.weight,
                  vpt_pallet: summary.amountPallets,
                  vpt_qtd_caixas: summary.amountBoxes,
                }}
              />
            )
          },
        }}
      />
    </Box>
  )
}
